import { render, staticRenderFns } from "./FormSubHeading.vue?vue&type=template&id=d9e8387a&"
import script from "./FormSubHeading.vue?vue&type=script&lang=ts&"
export * from "./FormSubHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports